import { trackEvent } from "@utils/api/tracker";
import { saveSurveyAnswers } from "src/utils/redux/slices/userData";
import { captureException } from "src/utils/sentry";
import { GoToPageOptions } from "src/pageDefinitions/goto/page-set";
import {
  isBuildPlanEligible,
  isInAppWebPurchaseEligible,
} from "src/utils/userSegment/features";
import goto from "src/pageDefinitions/goto";
import { isHM, isInApp } from "src/utils/userSegment";

const PAYMENT_SURVEY_NAMESPACE = "purchaseSurveyAnswers";

export const onCompletePaymentSurvey = async ({
  store,
  dispatch,
}: {
  params?: {
    finishedEvent?: string;
    lead?: string;

    dateKey?: string;
    extraProps?: JsonObject;
  };
} & GoToPageOptions): Promise<void> => {
  const { surveyAnswers } = store.getState();
  try {
    await dispatch(
      saveSurveyAnswers(surveyAnswers, {
        surveyNameSpace: PAYMENT_SURVEY_NAMESPACE,
        dateKey: "purchaseSurveyCompleteDateISO",
      })
    );

    trackEvent("FinishedPaymentSurvey", surveyAnswers);
    window.conversionTracker.trackViewContentWithParamsExsf0({
      content_type: "FBMG-FinishedPaymentSurvey",
    });

    // TODO: Put this all into the page set
    if (isInApp() && !isInAppWebPurchaseEligible()) {
      goto.nativePurchase();
    } else if (isBuildPlanEligible()) {
      goto.buildPlan();
    } else {
      goto.account(isHM());
    }
    // End Pageset
  } catch (e) {
    // TODO: Tag and throw or log and throw?
    captureException(e, "onCompletePurchaseSurvey");
    throw e;
  }
};
